import axios from 'axios';

class Catalogs {
  async fetch(page = 1) {
    try {
      const nonce = nlc_map_settings.catalogs_nonce;

      const response = await axios.get(nlc_map_settings.ajax_url, {
        params: {
          action: 'nlc_map_get_catalogs',
          _wpnonce: nonce,
          page: page,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        console.error('Error fetching catalogs:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching catalogs:', error);
    }
  }

  async search(query, page = 1) {
    try {
      const nonce = nlc_map_settings.search_catalogs_nonce;

      const response = await axios.get(nlc_map_settings.ajax_url, {
        params: {
          action: 'nlc_map_search_catalogs',
          _wpnonce: nonce,
          search: query,
          page: page,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        console.error('Error searching catalogs:', response.statusText);
      }
    } catch (error) {
      console.error('Error searching catalogs:', error);
    }
  }

  async browsePath(path = '') {
    try {
      const nonce = nlc_map_settings.browse_tree_nonce;

      const response = await axios.get(nlc_map_settings.ajax_url, {
        params: {
          action: 'nlc_map_browse_tree',
          _wpnonce: nonce,
          path: path,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        console.error('Error browsing tree:', response.statusText);
      }
    } catch (error) {
      console.error('Error browsing tree:', error);
    }
  }

  // Filter tiles by a user polygon. Returns response.data shaped as:
  //   { mode, totalSize, returnedSize, limit, offset, truncated, groups: [...] }
  // or null on error / aborted request.
  async getTilesByPolygon(geojsonPolygon, options = {}) {
    try {
      const nonce = nlc_map_settings.tiles_by_polygon_nonce;
      const params = new URLSearchParams();
      params.append('action', 'nlc_map_tiles_by_polygon');
      params.append('nonce', nonce);
      params.append('polygon', JSON.stringify(geojsonPolygon));
      if (options.mode) params.append('mode', options.mode);
      if (typeof options.limit === 'number') params.append('limit', String(options.limit));
      if (typeof options.offset === 'number') params.append('offset', String(options.offset));

      const response = await axios.post(nlc_map_settings.ajax_url, params, {
        signal: options.signal,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });

      if (response.status === 200 && response.data && response.data.success) {
        if (window.nlcMaps && window.nlcMaps.tabs) {
          window.nlcMaps.tabs._lastGetTilesByPolygonError = null;
        }
        return response.data.data;
      }
      const body = response.data || {};
      const errData = body.data || body;
      const message = errData.message || body.message || '(none)';
      const code = errData.code || body.code || response.status;
      console.error(
        '[nlc-maps] getTilesByPolygon failed.',
        'message:', message,
        'code:', code,
        'full body:', body
      );
      // Surface the error kind so callers can decide whether to retry (e.g.
      // with a bounding box) instead of just failing.
      if (window.nlcMaps && window.nlcMaps.tabs) {
        window.nlcMaps.tabs._lastGetTilesByPolygonError =
          /invalid/i.test(String(message)) ? 'invalid-polygon' : 'other';
      }
      return null;
    } catch (error) {
      if (axios.isCancel(error) || error.name === 'CanceledError') {
        return null;
      }
      console.error(
        '[nlc-maps] getTilesByPolygon error.',
        'status:', error.response && error.response.status,
        'body:', error.response && error.response.data,
        error
      );
      if (window.nlcMaps && window.nlcMaps.tabs) {
        window.nlcMaps.tabs._lastGetTilesByPolygonError = 'network';
      }
      return null;
    }
  }

  async getExactBounds(id) {
    try {
      const nonce = nlc_map_settings.tile_exact_bounds_nonce;
      const response = await axios.get(nlc_map_settings.ajax_url, {
        params: {
          action: 'nlc_map_tile_exact_bounds',
          _wpnonce: nonce,
          id: id,
        },
      });
      if (response.status === 200 && response.data && response.data.success) {
        const data = response.data.data;
        // Prefer corners if present (precise polygon shape)
        if (Array.isArray(data.wgs84Corners) && data.wgs84Corners.length >= 3) {
          return data.wgs84Corners;
        }
        return data.wgs84Bounds;
      }
    } catch (error) {
      console.error('Error fetching exact bounds:', error);
    }
    return null;
  }

  getCheckedCatalogs() {
    const checkboxes = document.querySelectorAll(
      '.js-nlc-maps-checkbox:checked'
    );
    const catalogData = [];

    checkboxes.forEach((checkbox) => {
      const id = checkbox.id;
      const title = checkbox.getAttribute('data-title');

      if (id && title) {
        catalogData.push({ id, title });
      }
    });

    return catalogData;
  }
}
export default Catalogs;
